import { BID_OPTIONS, BiddingGameState, GameStateStatus, PlayerTableViewModelV2 } from 'shared';
import { V2apiClient } from '../../ApiClient';
import { useApiCall } from '../../useApiCall';
import { Panel } from '../../ui/Panel';
import { Button } from '../../ui/Button';
import { Text } from '../../ui/Text';
import { zVar } from '../../ui/theme';

/*
 * BiddingButtons — Pass / 2 / 3 / 4 bid controls, shown when it's the local
 * player's turn to bid. Bids not in the server's possibleBids are disabled.
 * Replaces the SVG BiddingContainer + Pass/Two/Three/FourBid chrome.
 */

interface Props {
  table: PlayerTableViewModelV2;
}

const BIDS: { label: string; value: number }[] = [
  { label: 'Pass', value: 0 },
  ...BID_OPTIONS.map((value) => ({ label: String(value), value })),
];

export const BiddingButtons: React.FC<Props> = ({ table }) => {
  const apiCall = useApiCall();

  const bid = (value: number) => {
    void apiCall(V2apiClient.makeBid(value));
  };

  const possible =
    table.gameState?.status === GameStateStatus.Bidding
      ? (table.gameState as BiddingGameState).possibleBids
      : undefined;

  const allowed = (value: number) => !possible || possible.includes(value) || value === 0;

  return (
    <Panel
      variant="hud"
      style={{
        position: 'absolute',
        left: '50%',
        top: '46%',
        transform: 'translate(-50%, -50%)',
        zIndex: zVar('z-hud'),
        textAlign: 'center',
        display: 'grid',
        gap: 'var(--space-3)',
      }}
    >
      <Text variant="label">Place your bid</Text>
      <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
        {BIDS.map((option) => (
          <Button
            key={option.value}
            variant={option.value === 0 ? 'secondary' : 'primary'}
            size="lg"
            disabled={!allowed(option.value)}
            onClick={() => bid(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </Panel>
  );
};
